var map = {
	"./audio-placeholder": 801,
	"./audio-placeholder.png": 801,
	"./avatar-missing": 485,
	"./avatar-missing.png": 485,
	"./avatar-missing.svg": 850,
	"./halloween/clouds": 802,
	"./halloween/clouds.png": 802,
	"./halloween/halloween-emblem": 803,
	"./halloween/halloween-emblem.svg": 803,
	"./halloween/spider": 804,
	"./halloween/spider.svg": 804,
	"./halloween/spiderweb": 805,
	"./halloween/spiderweb.svg": 805,
	"./halloween/starfield": 806,
	"./halloween/starfield.png": 806,
	"./halloween/twinkle": 807,
	"./halloween/twinkle.svg": 807,
	"./header-missing": 631,
	"./header-missing.png": 631,
	"./reticle": 808,
	"./reticle.png": 808,
	"./soapbox-logo": 632,
	"./soapbox-logo-white": 633,
	"./soapbox-logo-white.svg": 633,
	"./soapbox-logo.svg": 632,
	"./sprite-post-functions": 809,
	"./sprite-post-functions.png": 809,
	"./video-placeholder": 810,
	"./video-placeholder.png": 810,
	"./void": 811,
	"./void.png": 811,
	"./web-push/web-push-icon_expand": 812,
	"./web-push/web-push-icon_expand.png": 812,
	"./web-push/web-push-icon_favourite": 813,
	"./web-push/web-push-icon_favourite.png": 813,
	"./web-push/web-push-icon_reblog": 814,
	"./web-push/web-push-icon_reblog.png": 814
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 849;